<template>
  <transition name="drawer-slide">
    <div
        v-if="show && (mobileFullscreen || width >= 768)"
        class="modal"
        :style="{'z-index': customIndex}"
    >
      <div @click.stop :class="`modal-content ${extraClasses}`">
        <slot></slot>
      </div>
    </div>
  </transition>
  <DrawerRoot
      v-if="!mobileFullscreen && width < 768"
      :open="show"
      :key="show"
      :dismissible="true"
      @update:open="val => {
        console.log('[CustomModal] Drawer update:open =', val)
        if (!val) emit('close')
      }"
  >
    <DrawerPortal>
      <DrawerOverlay class="fixed inset-0 bg-black/40 z-[9999]" />
      <DrawerContent
          class="fixed bottom-0 left-0 right-0 z-[9999] rounded-t-12xl bg-white p-4"
          :style="{ height: drawerHeight }"
      >
        <div
            class="flex items-center justify-center cursor-pointer pb-10"
            @click="emit('close')"
        >
          <div class="bg-bw-grey w-16 h-2 rounded-full transition hover:scale-110"></div>
        </div>
        <slot></slot>
      </DrawerContent>
    </DrawerPortal>
  </DrawerRoot>
</template>

<script setup lang="ts">
import { DrawerContent, DrawerOverlay, DrawerPortal, DrawerRoot } from 'vaul-vue'
import {onBeforeUnmount, onMounted, ref} from "vue";
import type { DrawerProps } from 'element-plus'
const direction = ref<DrawerProps['direction']>('btt')
// Define props and emits
const props = defineProps({
  show: Boolean,
  classes: String,
  mobileFullscreen: {
    default: true,
    type: Boolean,
    required: false,
  },
  drawerHeight: {
    default: "80%",
    type: String,
    required: false,
  },
  extraClasses: {
    default: "",
    type: String,
    required: false,
  },
  mobileClose: {
    default: false,
    type: Boolean,
    required: false,
  },
  customIndex: {
    default: 20,
    type: Number,
    required: false,
  },
});

const emit = defineEmits(["close"]);

import { toRef, watch } from 'vue'

const showRef = toRef(props, 'show')
const width = ref(window.innerWidth);

function resize() {
  width.value = window.innerWidth;
}

onMounted(() => {
  window.addEventListener("resize", resize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
});

watch(showRef, (newVal) => {
  console.log('[CustomModal] show changed:', newVal)
  document.documentElement.style.overflow = newVal ? 'hidden' : 'auto'
})

</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(190, 165, 170, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  pointer-events: auto; /* Ensures modal captures clicks */
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 100%;
  overflow-y: hidden;
  pointer-events: auto;
}
.drawer-overlay {
  pointer-events: auto; /* Blocks clicks outside the drawer */
}


.modal-enter-active {
  animation: modal 0.3s ease-out;
}

.modal-leave-active {
  animation: modal 0.3s ease-out;
}


@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 767px) {
  .modal-content {
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    border-radius: unset;
  }
}
.modal,
.modal-content {
  touch-action: manipulation;
}
</style>
